import { useMemo } from 'react';

import { Slider } from '@src/components/molecules/slider';
import { useCmsContent } from '@src/contexts/cms-content-context';

import { InfiniteGalleryImage, InfiniteGalleryWrapper } from './styles';

export const InfiniteGallery = () => {
  const content = useCmsContent();

  const imageLists = useMemo(() => {
    if (!content?.noTripsGallery?.length) {
      return undefined;
    }

    const dividerIndex = Math.floor(content.noTripsGallery.length / 2);
    const firstRow = content.noTripsGallery.slice(0, dividerIndex);
    const secondRow = content.noTripsGallery.slice(dividerIndex);

    return [firstRow, secondRow];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <InfiniteGalleryWrapper>
      {imageLists?.map((imageList, index) => (
        <Slider
          key={index}
          speed={20000}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
            stopOnLastSlide: false,
            waitForTransition: false,
            reverseDirection: index % 2 === 0,
          }}
          breakpoints={{
            0: {
              spaceBetween: 8,
            },
            768: {
              spaceBetween: 24,
            },
          }}
          slidesPerView="auto"
          pagination={false}
          loop
          useInfiniteSlider
        >
          {imageList.map(({ url }) => (
            <InfiniteGalleryImage key={url} src={url} />
          ))}
        </Slider>
      ))}
    </InfiniteGalleryWrapper>
  );
};

export default InfiniteGallery;
